import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Server-Side Rendering';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "server-side-rendering"
    }}>{`Server-Side Rendering`}</h1>
    <p>{`Because Rebass uses Emotion, no additional steps are required to support rendering on a server.
Emotion will automatically inline performant, critical CSS without any additional effort required.`}</p>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://emotion.sh/docs/ssr"
      }}>{`Emotion docs`}</a>{` for more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      